import React, { useState } from "react";

import type { NormalisedProduct } from "@app/scripts/types";

type Props = {
  variants: NormalisedProduct["variants"];
  handleChangeVariant: (e: React.ChangeEvent<HTMLSelectElement>) => void;
  defaultTitle?: string;
  selectedId?: string | number;
};

export const ProductSizeSelect: React.FC<Props> = ({
  variants,
  handleChangeVariant,
  defaultTitle = "Select size",
  selectedId,
}) => {
  const [defaultVisible, setDefaultVisible] = useState(true);

  const changeVariant: (e: React.ChangeEvent<HTMLSelectElement>) => void = (e) => {
    if (e.target.value !== "__default") {
      setDefaultVisible(false);
      handleChangeVariant(e);
    }
  };

  return variants && variants.length > 1 ? (
    <div className="product__variant-picker _field _field__select">
      <select className="select__select" name="Size" onChange={changeVariant} defaultValue={selectedId}>
        {!selectedId && defaultVisible && <option value="__default">{defaultTitle}</option>}
        {variants?.map((variant) => (
          <option key={variant.id} value={variant.id} disabled={variant.available !== true}>
            {variant.title}
          </option>
        ))}
      </select>
    </div>
  ) : null;
};
